/**
 * Discontinued-article detection, client side.
 *
 * FALLBACK ONLY. The real rule lives on the backend, in
 * `rep_rangingService.js` (`isDiscontinued`), because buyers mark a line
 * discontinued in the article's **brand** -- brand `DISC` outright, or with a
 * word either side: `PNP DISC`, `OAKMONT DISC`, `MOJOME DISC`. Brand never
 * reaches the browser, so the server ships a per-column verdict in
 * `head.disc` and the Ranging grid filters on that.
 *
 * A few Dis-Chem lines carry the marker in the description instead
 * (`XEROSTOM MOUTHWASH 250ML (disc)`). That is the only part a client-side
 * test can see, and it is what this function is for: if the API answers
 * without `head.disc` -- a backend deployed before the flag existed -- the
 * toggle still catches those rather than going silently dead.
 *
 * If you find yourself extending this, you are in the wrong file: extend the
 * backend rule and let it travel in `head.disc`.
 */
export const isDiscontinued = (articleName) => /disc/i.test(String(articleName ?? ""));

export default isDiscontinued;
